import { apiService } from "./apiService";
import { IManager } from "../types/manager";

export const ManagersService = {
    save: (newManager: any) => {
        const managerDB = ManagersService.removeUnusedKeys(newManager);
        return apiService.post('/api/managers', { newManager: managerDB }).catch((error) => {
            if (error.status === 409) {
                throw { message: 'The user already exists', controled: true }
            }
            throw error;
        });
    },
    update: (before: IManager, after: IManager) => {
        return apiService.put('/api/managers', { updateManager: { before, after } });
    },
    delete: (managerId: string) => {
        return apiService.delete(`/api/managers/${managerId}`);
    },
    search: (request): Promise<{ managers: IManager[]; total: number }> => {
        return apiService.post('/api/managers/all', { request }).then(res => {
            const { data } = res
            return res.status === 200 && data;
        })
    },
    getByID: (managerId: string): Promise<IManager | null> => {
        return apiService.get(`/api/managers/${managerId}`).then(res => {
            const { data } = res;
            return res.status === 200 && data.manager ? data.manager as IManager : null;
        })
    },
    removeUnusedKeys: (newManager: any) => {
        const cleanedManager = newManager;
        delete cleanedManager.isNew;
        return cleanedManager;
    }
}


// WEBPACK FOOTER //
// ./src/share/services/managers.ts